import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
// import "./Styles.scss"
import "./Styles.css"
import { BrowserRouter } from 'react-router-dom';
// import Carousel from './components/Carousel';



const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
 <BrowserRouter>
    <App />
    </BrowserRouter>
 
);
